var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.applyClass},[_c(_vm.variant,{tag:"component",class:_vm.textClass},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }